// FLOW-01 (task 5.3) — os tipos de passo como o canvas os mostra: a família (que dá a cor), o
// ícone e os textos da biblioteca, nas 8 categorias do mockup v3 (`Canvas.dc.html`). Só os tipos do
// v1 são passos de verdade; os outros aparecem na biblioteca com o selo "v2", desabilitados, para
// quem monta o flow saber o que vem.
//
// As classes vão escritas por inteiro (e não montadas): o Tailwind só gera a classe que encontra no
// código.
//
// FLOW-04 (task 4.1): `for_each`, `while` e `aggregate` saem do "em breve", com os nomes do schema
// (o `loop` daqui virou os dois laços), e o `merge` sai da biblioteca: quem junta listas é o
// `aggregate`, e os ramos já se juntam sozinhos no passo seguinte.
// As cores das famílias não usam as cores de estado (impeccable, 10/10): na depuração, teal é ok,
// âmbar é pausado ou aviso, rubi é erro, azul é rodando e magenta é seleção e ação. Com elas, o
// ícone teal de "Confirma ao cliente" ao lado do contorno teal de sucesso confundia o tipo do passo
// com o resultado dele. Sobram cinco matizes para oito famílias: algumas dividem a cor, e o ícone
// diz o tipo.
//
// FLOW-05 (task 5.1): os quatro passos de arquivo entram com as famílias do PLAN P5: ler anexos é
// integração (busca fora do flow, na conversa), reduzir imagem e gerar PDF são dados (transformam o
// que o flow já tem) e entregar é conversa (fala com o cliente).
export const FAMILIAS = {
  integracao: {
    chip: 'bg-n-orange-3 text-n-orange-11',
    texto: 'text-n-orange-11',
    mini: 'fill-n-orange-9',
  },
  fluxo: {
    chip: 'bg-n-violet-3 text-n-violet-11',
    texto: 'text-n-violet-11',
    mini: 'fill-n-violet-9',
  },
  dados: {
    chip: 'bg-n-iris-3 text-n-iris-11',
    texto: 'text-n-iris-11',
    mini: 'fill-n-iris-9',
  },
  validacao: {
    chip: 'bg-n-gray-3 text-n-gray-11',
    texto: 'text-n-gray-11',
    mini: 'fill-n-gray-9',
  },
  codigo: {
    chip: 'bg-n-slate-3 text-n-slate-12',
    texto: 'text-n-slate-12',
    mini: 'fill-n-slate-11',
  },
  ia: {
    chip: 'bg-n-iris-3 text-n-iris-11',
    texto: 'text-n-iris-11',
    mini: 'fill-n-iris-9',
  },
  conversa: {
    chip: 'bg-n-violet-3 text-n-violet-11',
    texto: 'text-n-violet-11',
    mini: 'fill-n-violet-9',
  },
  catalogo: {
    chip: 'bg-n-orange-3 text-n-orange-11',
    texto: 'text-n-orange-11',
    mini: 'fill-n-orange-9',
  },
};

// `tipo` é o `type` do YAML. A família do `respond` é a dos dados, como no mockup: ele devolve o
// resultado e segue, embora more na categoria Fluxo da biblioteca. O `return` (16/10, pedido do
// Murilo) é da família do fluxo, a dos passos de controle, como o `fail`: os dois terminam o
// caminho. O ícone dele é a seta que volta até a parede (`arrow-left-to-line`): devolve a resposta
// a quem chamou e para ali. A seta curva de antes (`corner-down-left`, o Enter do teclado) não dizia
// isso; a `reply` já é do `respond`, a `undo-2` lê como desfazer e a `log-out` como sair da conta.
export const TIPOS = {
  tool: {
    familia: 'catalogo',
    icone: 'i-lucide-package',
  },
  http: {
    familia: 'integracao',
    icone: 'i-lucide-globe',
  },
  webhook: {
    familia: 'integracao',
    icone: 'i-lucide-webhook',
    v2: true,
  },
  attachments: {
    familia: 'integracao',
    icone: 'i-lucide-paperclip',
  },
  if: {
    familia: 'fluxo',
    icone: 'i-lucide-git-branch',
  },
  switch: {
    familia: 'fluxo',
    icone: 'i-lucide-split',
  },
  branches: {
    familia: 'fluxo',
    icone: 'i-lucide-route',
  },
  // FLOW-04: os laços são da família do fluxo, como o `if`; o `aggregate` é da dos dados.
  for_each: {
    familia: 'fluxo',
    icone: 'i-lucide-repeat',
  },
  while: {
    familia: 'fluxo',
    icone: 'i-lucide-iteration-cw',
  },
  wait: {
    familia: 'fluxo',
    icone: 'i-lucide-clock',
    v2: true,
  },
  subflow: {
    familia: 'fluxo',
    icone: 'i-lucide-workflow',
    v2: true,
  },
  respond: {
    familia: 'dados',
    icone: 'i-lucide-reply',
  },
  return: {
    familia: 'fluxo',
    icone: 'i-lucide-arrow-left-to-line',
  },
  fail: {
    familia: 'fluxo',
    icone: 'i-lucide-octagon-x',
  },
  set: {
    familia: 'dados',
    icone: 'i-lucide-pencil-line',
  },
  filter: {
    familia: 'dados',
    icone: 'i-lucide-funnel',
  },
  sort: {
    familia: 'dados',
    icone: 'i-lucide-arrow-up-down',
  },
  aggregate: {
    familia: 'dados',
    icone: 'i-lucide-sigma',
  },
  date: {
    familia: 'dados',
    icone: 'i-lucide-calendar',
  },
  'image.normalize': {
    familia: 'dados',
    icone: 'i-lucide-image',
  },
  'document.render': {
    familia: 'dados',
    icone: 'i-lucide-file-text',
  },
  validate: {
    familia: 'validacao',
    icone: 'i-lucide-shield-check',
  },
  code: {
    familia: 'codigo',
    icone: 'i-lucide-code-xml',
  },
  classify: {
    familia: 'ia',
    icone: 'i-lucide-brain',
    v2: true,
  },
  extract: {
    familia: 'ia',
    icone: 'i-lucide-brain',
    v2: true,
  },
  agent: {
    familia: 'ia',
    icone: 'i-lucide-bot',
    v2: true,
  },
  artifact: {
    familia: 'conversa',
    icone: 'i-lucide-send',
  },
  message: {
    familia: 'conversa',
    icone: 'i-lucide-message-square',
    v2: true,
  },
  ask: {
    familia: 'conversa',
    icone: 'i-lucide-circle-help',
    v2: true,
  },
  handoff: {
    familia: 'conversa',
    icone: 'i-lucide-headset',
    v2: true,
  },
};

export const CATEGORIAS = [
  {
    chave: 'catalogo',
    familia: 'catalogo',
    icone: 'i-lucide-package',
    tipos: ['tool'],
  },
  {
    chave: 'integracoes',
    familia: 'integracao',
    icone: 'i-lucide-globe',
    tipos: ['http', 'attachments', 'webhook'],
  },
  {
    chave: 'fluxo',
    familia: 'fluxo',
    icone: 'i-lucide-git-branch',
    tipos: [
      'if',
      'switch',
      'branches',
      'for_each',
      'while',
      'respond',
      'return',
      'fail',
      'wait',
      'subflow',
    ],
  },
  {
    chave: 'dados',
    familia: 'dados',
    icone: 'i-lucide-layers',
    tipos: [
      'set',
      'filter',
      'sort',
      'date',
      'aggregate',
      'image.normalize',
      'document.render',
    ],
  },
  {
    chave: 'validacao',
    familia: 'validacao',
    icone: 'i-lucide-shield-check',
    tipos: ['validate'],
  },
  {
    chave: 'codigo',
    familia: 'codigo',
    icone: 'i-lucide-code-xml',
    tipos: ['code'],
  },
  {
    chave: 'ia',
    familia: 'ia',
    icone: 'i-lucide-brain',
    tipos: ['classify', 'extract', 'agent'],
  },
  {
    chave: 'conversa',
    familia: 'conversa',
    icone: 'i-lucide-message-square',
    tipos: ['artifact', 'message', 'ask', 'handoff'],
  },
];

// Os textos da biblioteca. Cada `t` leva a chave inteira, sem chave montada: é ela que o grep acha
// e que a regra `no-dynamic-keys` confere.
const montarTextosDosTipos = t => ({
  tool: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.TOOL.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.TOOL.DESC'),
  },
  http: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.HTTP.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.HTTP.DESC'),
  },
  webhook: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.WEBHOOK.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.WEBHOOK.DESC'),
  },
  attachments: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.ATTACHMENTS.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.ATTACHMENTS.DESC'),
  },
  'image.normalize': {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.IMAGE_NORMALIZE.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.IMAGE_NORMALIZE.DESC'),
  },
  'document.render': {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.DOCUMENT_RENDER.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.DOCUMENT_RENDER.DESC'),
  },
  artifact: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.ARTIFACT.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.ARTIFACT.DESC'),
  },
  if: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.IF.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.IF.DESC'),
  },
  switch: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.SWITCH.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.SWITCH.DESC'),
  },
  branches: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.BRANCHES.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.BRANCHES.DESC'),
  },
  for_each: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.FOR_EACH.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.FOR_EACH.DESC'),
  },
  while: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.WHILE.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.WHILE.DESC'),
  },
  wait: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.WAIT.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.WAIT.DESC'),
  },
  subflow: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.SUBFLOW.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.SUBFLOW.DESC'),
  },
  respond: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.RESPOND.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.RESPOND.DESC'),
  },
  return: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.RETURN.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.RETURN.DESC'),
  },
  fail: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.FAIL.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.FAIL.DESC'),
  },
  set: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.SET.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.SET.DESC'),
  },
  filter: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.FILTER.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.FILTER.DESC'),
  },
  sort: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.SORT.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.SORT.DESC'),
  },
  aggregate: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.AGGREGATE.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.AGGREGATE.DESC'),
  },
  date: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.DATE.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.DATE.DESC'),
  },
  validate: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.VALIDATE.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.VALIDATE.DESC'),
  },
  code: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.CODE.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.CODE.DESC'),
  },
  classify: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.CLASSIFY.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.CLASSIFY.DESC'),
  },
  extract: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.EXTRACT.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.EXTRACT.DESC'),
  },
  agent: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.AGENT.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.AGENT.DESC'),
  },
  message: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.MESSAGE.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.MESSAGE.DESC'),
  },
  ask: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.ASK.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.ASK.DESC'),
  },
  handoff: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.HANDOFF.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.HANDOFF.DESC'),
  },
});

// FLOW-11 (task 5.12, §2.2): cada nó do canvas pede os textos, e montá-los custava 60 traduções por
// nó (326 ms ao abrir o flow de 300 passos). Guardados por `t` e pelo idioma (a marca é um texto que
// muda de um idioma para outro), saem uma vez só.
const TEXTOS_GUARDADOS = new WeakMap();
export function textosDosTipos(t) {
  const marca = t('POWER_TOOLS.FLOW_EDITOR.CANVAS.STEPS.TOOL.NAME');
  const guardado = TEXTOS_GUARDADOS.get(t);
  if (guardado?.marca === marca) return guardado.textos;
  const textos = montarTextosDosTipos(t);
  TEXTOS_GUARDADOS.set(t, { marca, textos });
  return textos;
}

export const textosDasCategorias = t => ({
  catalogo: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.CATALOG.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.CATALOG.DESC'),
  },
  integracoes: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.INTEGRATIONS.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.INTEGRATIONS.DESC'),
  },
  fluxo: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.FLOW.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.FLOW.DESC'),
  },
  dados: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.DATA.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.DATA.DESC'),
  },
  validacao: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.VALIDATION.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.VALIDATION.DESC'),
  },
  codigo: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.CODE.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.CODE.DESC'),
  },
  ia: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.AI.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.AI.DESC'),
  },
  conversa: {
    nome: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.CONVERSATION.NAME'),
    desc: t('POWER_TOOLS.FLOW_EDITOR.CANVAS.CATEGORIES.CONVERSATION.DESC'),
  },
});

// O MIME do arrastar da biblioteca para o canvas: o texto é o `type` do passo.
export const ARRASTE = 'application/x-powerflow-passo';
